import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink, from, NormalizedCacheObject } from '@apollo/client'
import 'bootstrap/dist/css/bootstrap.min.css';
import { onError } from '@apollo/client/link/error';
import { Provider } from "react-redux";
import { applyMiddleware, combineReducers, createStore } from "redux";
import CoreRouter from './components/coreRouter/coreRouter';
import thunk from "redux-thunk";
import questionReducer from './store/reducer/questions.reducer';
import { ReactNotifications } from 'react-notifications-component';
import ReactGA from 'react-ga4';
import { IdToken, useAuth0 } from "@auth0/auth0-react";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import 'rsuite/dist/rsuite.min.css'; // or 'rsuite/dist/rsuite.min.css'
import './App.css'; // main style file
import { useEffect, useState } from 'react';
import { setContext } from "apollo-link-context";
import { createHttpLink } from "apollo-link-http";
import { getENVData } from './constants/constantValue';
import { IsConnected } from './store/actions';
import Helper from "./Helper";

const ENV = getENVData()

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) => {
      console.error("graphQLErrors", message, locations, path)
      return true;
    })
  }
})
ReactGA.initialize(ENV.ReactGA);
const rootReducer = combineReducers({
  Question: questionReducer,
});
export type RootState = ReturnType<typeof rootReducer>

const store = createStore(rootReducer, applyMiddleware(thunk));
const App = () => {
  const [client, setClient] = useState<ApolloClient<NormalizedCacheObject>>()
  const { isAuthenticated, isLoading, getIdTokenClaims } = useAuth0();

  useEffect(() => {
    if (isAuthenticated) {
      getToken();
    } else {
      const link = from([
        errorLink,
        new HttpLink({ uri: ENV.GraphQlUrl })
      ])
      setClient(new ApolloClient({
        cache: new InMemoryCache(),
        link: link
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  const getToken = async () => {
    const data: IdToken | undefined = await getIdTokenClaims();

    const httpLink = createHttpLink({
      uri: ENV.GraphQlUrl
    });
    const authLink = setContext((_, { headers }) => {
      return {
        headers: {
          ...headers,
          "X-Auth-Token": data?.__raw,
        },
      };
    });
    const link = from([
      errorLink.concat(authLink.concat(httpLink) as any) as any,
      new HttpLink({ uri: ENV.GraphQlUrl })
    ])
    setClient(new ApolloClient({
      cache: new InMemoryCache(),
      link: link
    }));

   
    Helper.token = data!.__raw;

    (window as any).itineraryViewer = {
      token: data?.__raw,
      dgraphQUrl: ENV.GraphQlUrl,
    };
  }

  const eventAction = (event: Event) => {
    const customEvent = event as CustomEvent<{ id: string }>;
    store.dispatch(IsConnected(customEvent.detail.id));
  }

  useEffect(() => {
    const mycontrol = document.getElementById("root");

    if (mycontrol) {
      mycontrol.addEventListener("itineraryViewer", eventAction as EventListener);

      return () => mycontrol.removeEventListener("itineraryViewer", eventAction);
    }
  }, []);

  return (
    <Provider store={store}>
      <ReactNotifications />
      <div id="pdfPreview"></div>
      <div id="main-content" ></div>
      {!isLoading && client && <ApolloProvider client={client}>
        <CoreRouter />
      </ApolloProvider>}
      <div className='Main'>
        <div className="mainloader">
        </div>
      </div>
    </Provider>
  );
}

export default App;
